// extracted by mini-css-extract-plugin
export var button = "Button-module--button--ECaJB";
export var endIcon = "Button-module--endIcon--lEk5A";
export var startIcon = "Button-module--startIcon--88v7-";
export var wrapper = "Button-module--wrapper--X2gN6";